export const digitUtil = (num = 0, digit) => {
  let dig = Math.pow(10, digit);
  num = Math.round(parseFloat(num) * dig) / dig;

  let suffix = '.';
  if (num.toString().indexOf('.') < 0) {
    for (let i = 0; i < digit; i++) {
      suffix = suffix + '0';
    }
    num = num.toString() + suffix;
  } else {
    let numSplit = num.toString().split('.');
    let suffixLength = digit - numSplit[1].length;
    suffix = suffix + numSplit[1];
    for (let i = 0; i < suffixLength; i++) {
      suffix = suffix + '0';
    }
    num = numSplit[0] + suffix;
  }
  return num;
};

/* ============================================================
 * 运维角色判定
 *   当前（正式环境）：['6', '7']    充电桩运维团队 / 充电桩运维主管
 * ============================================================ */
const OPS_ROLE_CODES = ['6', '7'];

// 非运维、未登录、字段缺失、异常 —— 一律返回 false
export const isOpsUser = () => {
  try {
    // 联调开关，仅非生产构建生效
    if (process.env.NODE_ENV !== 'production') {
      if (window.localStorage.getItem('__ops_debug') === '1') return true;
    }
    // 只能读 localStorage.roleCodes，store 里的会被 getUserInfo 覆盖成 null
    const code = String(window.localStorage.getItem('roleCodes') || '');
    return OPS_ROLE_CODES.includes(code);
  } catch (e) {
    return false;
  }
};
